import axios from 'axios';


const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api',
  withCredentials: true, // This is all you need for cookie-based auth
});

// ❌ REMOVE THE INTERCEPTOR, it's not needed for your backend's auth system

export default api;